import React from 'react';

import cn from 'classnames';

import styles from './Label.module.css';

export const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...labelProps }, ref) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label ref={ref} className={cn(styles.label, className)} {...labelProps} />
  );
});

Label.displayName = 'Label';
